module.exports = __webpack_public_path__ + "img/GMMC.388b1a0f.jpg";